import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function ParkDialog({ open, onOpenChange, onConfirm, pending }: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  onConfirm: (v: { revisitOn: string | null; reason: string | null }) => void;
  pending?: boolean;
}) {
  const [revisitOn, setRevisitOn] = useState("");
  const [reason, setReason] = useState("");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>Park in Nurture</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">The owner is not selling this year. Pick when to look again; the prospect leaves the active list until then and keeps its stage.</p>
        <div className="space-y-3">
          <div className="space-y-1"><Label className="text-xs">Revisit</Label><Input type="date" value={revisitOn} onChange={(e) => setRevisitOn(e.target.value)} /></div>
          <div className="space-y-1"><Label className="text-xs">Why</Label><Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Not before the next tax year" /></div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button disabled={pending} onClick={() => onConfirm({ revisitOn: revisitOn || null, reason: reason || null })}>Park</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
